import { LoginUser } from "../components/common/constants";
import types from "./ActionTypes";

const initialState = {
    // userData
    IsMTPLAdmin: false,
    IsAdmin: false,
    IsBranchAdmin: false,
    CompanyID: '',
    UserID: '',
    CountryID: '',
    BranchName: '',
    CompanyName: '',
    UserName: '',
    RoleID: '',
    BranchID: '',
    CityID: '',
    StateID: '',
    MultiplePayments: 0,
    MobileLowerLimit: 0,
    MobileUpperLimit: 0,
    AccountingProductId: 0,
    IsCollBoyRequestPayment: 0,
    isSTACompanyID: 0,
    CounterID: 0,

    agentRight: {
        agents: false,
        agentVoucher: false,
        agentRecharge: false,
    },

    loading: false,
    loadingScreen: false,
    loginData: {},
    menuVisible: false,
    mainMenu: true,
    serviceMasterMenu: false,
    stockMasterMenu: false,
    othersMenu: false,
    routeMasterMenu: false,
    casualContractMenu: false,
    userConfigMenu: false,
    cargoRateConfig: false,
    masterConfigMenu: false,
    bookingMenuOpen: false,
    topUpMenuOpen: false,
    KSDTCBookingMenuOpen: false,
    roleData: [],
    layoutConfigMenu: false,
    fareMasterMenu: false,
    reportsMenu: false,
    cargoReportMainMenu: false,
    generalReportsMenu: false,
    accountsReportsMenu: false,
    onlineReportsMenu: false,
    otherReportsMenu: false,
    cargoReportMenu: false,
    pprManagementMenu: false,
    cargoBookingMenu: false,
    casualContractReportsMenu: false,
    kstdcReportsMenu: false,
    ipAddress: '',
    complaintManagementMenu: false,
    ADV_RESERV_DAYS: 30,
    masterCodeValue: [],
    SERVICE_CANCEL_DAYS_FOR_APPLICATION_ADMIN: 0,
    cargoDcReportMenu: false,
    cargoDashboardReportMenu: false,
    cargoOpertionsReportMenu: false,
    cargoAccountsReportMenu: false,

};

const Reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.LOG_IN:
            return {
                ...state,
                IsMTPLAdmin: action.payload.IsMTPLAdmin,
                IsAdmin: action.payload.IsAdmin,
                IsBranchAdmin: action.payload.IsBranchAdmin,
                CompanyID: action.payload.CompanyID,
                UserID: action.payload.UserID,
                CountryID: action.payload.CountryID,
                BranchName: action.payload.BranchName,
                CompanyName: action.payload.CompanyName,
                UserName: action.payload.UserName,
                RoleID: action.payload.RoleID,
                BranchID: action.payload.BranchID,
                CityID: action.payload.CityID,
                StateID: action.payload.StateID,
                MultiplePayments: action.payload.MultiplePayments,
                MobileLowerLimit: action.payload.MobileLowerLimit,
                MobileUpperLimit: action.payload.MobileUpperLimit,
                AccountingProductId: action.payload.AccountingProductId,
                IsCollBoyRequestPayment: action.payload.IsCollBoyRequestPayment,
                isSTACompanyID: action.payload.isSTACompanyID,
                CounterID: action.payload.CounterID,
                agentRight: action.agentRight,
                ADV_RESERV_DAYS: action.payload.ADV_RESERV_DAYS,
                loading: false,
                loadingScreen: false
            };

        case types.UPDATE_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case types.UPDATE_LOADING_SCREEN:
            return {
                ...state,
                loadingScreen: action.payload
            };

        case types.LOGIN_DATA:
            return {
                ...state,
                loginData: action.payload
            };
        case types.MENU_VISIBLE:
            return {
                ...state,
                menuVisible: !state.menuVisible
            };
        case types.MAIN_MENU:
            return {
                ...state,
                mainMenu: action.payload
            };
        case types.SERVICE_MASTER_MENU:
            return {
                ...state,
                serviceMasterMenu: action.payload
            };
        case types.STOCK_MANAGEMENT_MENU:
            return {
                ...state,
                stockMasterMenu: action.payload
            };
        case types.OTHERS_MENU:
            return {
                ...state,
                othersMenu: action.payload
            };
        case types.ROUTE_MENU:
            return {
                ...state,
                routeMasterMenu: action.payload
            };
        case types.CASUAL_CONTRACT_MENU:
            return {
                ...state,
                casualContractMenu: action.payload
            };
        case types.USER_CONFIG_MENU:
            return {
                ...state,
                userConfigMenu: action.payload
            };
        case types.CARGO_RATE_CONFIG:
            return {
                ...state,
                cargoRateConfig: action.payload
            }

        case types.LAYOUT_CONFIG_MENU:
            return {
                ...state,
                layoutConfigMenu: action.payload
            };
        case types.FARE_CONFIG_MENU:
            return {
                ...state,
                fareMasterMenu: action.payload
            };

        case types.MASTER_CONFIG_MENU:
            return {
                ...state,
                masterConfigMenu: action.payload
            };
        case types.BOOKING_MENU:
            return {
                ...state,
                bookingMenuOpen: action.payload
            };
        case types.TOP_UP_MENU:
            return {
                ...state,
                topUpMenuOpen: action.payload
            };
        case types.KSDTC_BOOKING_MENU:
            return {
                ...state,
                KSDTCBookingMenuOpen: action.payload
            };

        case types.UPDATE_USER_DATA:
            return {
                ...state,
                ...action.payload
            }

        case types.LOGOUT:
            return {
                ...state,
                ...LoginUser
            }
        case types.REPORT_MENU:
            return {
                ...state,
                generalReportsMenu: false,
                accountsReportsMenu: false,
                onlineReportsMenu: false,
                otherReportsMenu: false,
                kstdcReportsMenu: false,
                reportsMenu: action.payload,
                kstdcReportsMenu: false
            };
        case types.GENERAL_REPORT_MENU:
            return {
                ...state,
                reportsMenu: false,
                generalReportsMenu: action.payload,
                accountsReportsMenu: false,
                onlineReportsMenu: false,
                otherReportsMenu: false,
                kstdcReportsMenu: false
            };
        case types.CASUAL_CONTRACT_REPORT_MENU:
            return {
                ...state,
                casualContractMenu: false,
                casualContractReportsMenu: action.payload,
            };
        case types.ACCOUNTS_REPORT_MENU:
            return {
                ...state,
                reportsMenu: false,
                generalReportsMenu: false,
                accountsReportsMenu: action.payload,
                onlineReportsMenu: false,
                otherReportsMenu: false,
                kstdcReportsMenu: false
            };
        case types.ONLINE_REPORT_MENU:
            return {
                ...state,
                reportsMenu: false,
                generalReportsMenu: false,
                accountsReportsMenu: false,
                onlineReportsMenu: action.payload,
                otherReportsMenu: false,
                kstdcReportsMenu: false
            };
        case types.OTHER_REPORT_MENU:
            return {
                ...state,
                reportsMenu: false,
                generalReportsMenu: false,
                accountsReportsMenu: false,
                onlineReportsMenu: false,
                kstdcReportsMenu: false,
                otherReportsMenu: action.payload
            };
        //--------
        case types.CARGO_REPORT_MAIN_MENU:
            return {
                ...state,
                cargoReportMainMenu: action.payload,
                cargoDcReportMenu: false,
                cargoDashboardReportMenu: false,
                cargoOpertionsReportMenu: false,
                cargoAccountsReportMenu: false,
            };
        case types.CARGO_DC_REPORT_MENU:
            return {
                ...state,
                cargoReportMainMenu: false,
                cargoDcReportMenu: action.payload,
                cargoDashboardReportMenu: false,
                cargoOpertionsReportMenu: false,
                cargoAccountsReportMenu: false
            };
        case types.CARGO_DASHBOARD_REPORT_MENU:
            return {
                ...state,
                cargoReportMainMenu: false,
                cargoDcReportMenu: false,
                cargoDashboardReportMenu: action.payload,
                cargoOpertionsReportMenu: false,
                cargoAccountsReportMenu: false
            };
        case types.CARGO_OPERATIONS_REPORT_MENU:
            return {
                ...state,
                cargoReportMainMenu: false,
                cargoDcReportMenu: false,
                cargoDashboardReportMenu: false,
                cargoOpertionsReportMenu: action.payload,
                cargoAccountsReportMenu: false
            };
        case types.CARGO_ACCOUNTS_REPORT_MENU:
            return {
                ...state,
                cargoReportMainMenu: false,
                cargoDcReportMenu: false,
                cargoDashboardReportMenu: false,
                cargoOpertionsReportMenu: false,
                cargoAccountsReportMenu: action.payload
            };
        case types.CARGO_REPORT_MENU:
            return {
                ...state,
                cargoReportMenu: action.payload
            }
        case types.PPR_MANAGEMENT_MENU:
            return {
                ...state,
                pprManagementMenu: action.payload
            }
        case types.CARGO_MENU:
            return {
                ...state,
                cargoBookingMenu: action.payload
            }

        case types.KSTDC_REPORT_MENU:
            return {
                ...state,
                reportsMenu: false,
                generalReportsMenu: false,
                accountsReportsMenu: false,
                onlineReportsMenu: false,
                otherReportsMenu: false,
                kstdcReportsMenu: action.payload
            };
        case types.UPDATE_IP_ADDRESS:
            return {
                ...state,
                ipAddress: action.payload,
            };
        case types.MASTER_CODE_ALLVALUE:
            return {
                ...state,
                masterCodeValue: action.payload
            };
        case types.COMPLAINT_MANAGEMENT:
            return {
                ...state,
                complaintManagementMenu: action.payload,
            };
        case types.UPDATE_REVOKE_SERIVE_DATE:
            return {
                ...state,
                ...action.payload
            };
        case types.ROLE_DATA:
            return {
                ...state,
                roleData: action.payload
            };
        case types.CARGO_REPORT_MAIN_MENU:
            return {
                ...state,
                cargoReportMainMenu: action.payload,
                cargoDcReportMenu: false,
                cargoDashboardReportMenu: false,
                cargoOpertionsReportMenu: false,
                cargoAccountsReportMenu: false,
            };
        case types.CARGO_DC_REPORT_MENU:
            return {
                ...state,
                cargoReportMainMenu: false,
                cargoDcReportMenu: action.payload,
                cargoDashboardReportMenu: false,
                cargoOpertionsReportMenu: false,
                cargoAccountsReportMenu: false
            };
        case types.CARGO_DASHBOARD_REPORT_MENU:
            return {
                ...state,
                cargoReportMainMenu: false,
                cargoDcReportMenu: false,
                cargoDashboardReportMenu: action.payload,
                cargoOpertionsReportMenu: false,
                cargoAccountsReportMenu: false
            };
        case types.CARGO_OPERATIONS_REPORT_MENU:
            return {
                ...state,
                cargoReportMainMenu: false,
                cargoDcReportMenu: false,
                cargoDashboardReportMenu: false,
                cargoOpertionsReportMenu: action.payload,
                cargoAccountsReportMenu: false
            };
        case types.CARGO_ACCOUNTS_REPORT_MENU:
            return {
                ...state,
                cargoReportMainMenu: false,
                cargoDcReportMenu: false,
                cargoDashboardReportMenu: false,
                cargoOpertionsReportMenu: false,
                cargoAccountsReportMenu: action.payload
            };
        default:
            return state;

    }
}

export default Reducer;